var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
    'button',
    {
      'button_full-width': _vm.fullWidth,
      button_disabled: _vm.disabled,
      'button_disabled-color': _vm.color === 'disabled',
      button_primary: _vm.color === 'primary',
      button_secondary: _vm.color === 'secondary',
      button_link: _vm.color === 'link',
      'button_link-secondary': _vm.color === 'link-secondary',
      'button_secondary-fill': _vm.color === 'secondary-fill',
      button_danger: _vm.color === 'danger',
      button_warning: _vm.color === 'warning',
    } ],attrs:{"id":_vm.id,"disabled":_vm.disabled || _vm.loading},on:{"click":function($event){return _vm.$emit('click')}}},[(!_vm.loading)?_vm._t("default"):_c('div',{staticClass:"button-loader"},[_c('div',{staticClass:"dot dot-1"}),_c('div',{staticClass:"dot dot-2"}),_c('div',{staticClass:"dot dot-3"})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }